import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Card from "../components/common/card";
import { faMailBulk, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {

	faGithub,

	faInstagram,
	faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Article from "../components/homepage/article";
import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles from "../data/articles";

import "./styles/homepage.css";
import img from "./mypic.jpg";
// import Projects from "./projects";

const Homepage = () => {
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(80);
	const [oldLogoSize, setOldLogoSize] = useState(80);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.pageYOffset, 2);

			let newLogoSize = 80 - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const currentSEO = SEO.find((item) => item.page === "home");

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "3vh" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};
	console.log()
	return (
		<React.Fragment>
			<Helmet>
				<title >{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>

			</Helmet>

			<div className="page-content">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						<div style={logoStyle}>
							<Logo width={logoSize} link={false} />
						</div>
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">

								<div className="title homepage-title">
									<h1 style={{ color: "#8a45e4" }} >{INFO.main.name}</h1>
									<h3 style={{ marginTop: "-30px", fontSize: "40px" }}>{INFO.homepage.title}</h3>
								</div>

								<div className="subtitle homepage-subtitle">
									{INFO.homepage.description && (
										<h4 style={{ fontSize: "20px" }}>{INFO.homepage.description}</h4>
									)}
									{INFO.homepage.description2 && (
										<h4 style={{ fontSize: "20px" }}>{INFO.homepage.description2}</h4>
									)}
									{INFO.homepage.description3 && (
										<h4 style={{ fontSize: "20px" }}>{INFO.homepage.description3}</h4>
									)}
									{INFO.homepage.description4 && (
										<h4 style={{ fontSize: "20px" }}>{INFO.homepage.description4}</h4>
									)}
								</div>
							</div>

							<div className="homepage-first-area-right-side">
								<div className="homepage-image-container">
									<div className="homepage-image-wrapper">
										<img
											src={img}
											alt="about"
											className="homepage-image"
										/>
									</div>
								</div>
							</div>
						</div>




						<h3 style={{ fontSize: "40px", fontWeight: "600px" }}>Articles & Work</h3>
						<div className="homepage-after-title">
							{/* <h3 style={{fontSize:"40px", fontWeight:"600px"}}>Articles</h3> */}
							<div className="homepage-articles">
								{myArticles.map((article, index) => (
									<div
										className="homepage-article"
										key={(index + 1).toString()}
									>
										<Article
											key={(index + 1).toString()}
											date={article().date}
											title={article().title}
											description={article().description}
											link={article().link}
										/>
									</div>
								))}
								<div className="homepage-projects">
									<h3 style={{ fontSize: "40px", fontWeight: "600px" }}>Projects</h3>
									<AllProjects />
								</div>
							</div>


							<div className="homepage-works">
								<Works />

							</div>

						</div>
						<div className="homepage-socials">
							{/* <a
								href={INFO.socials.twitter}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									style={{width:40,height:40}}
									icon={faTwitter}
									className="homepage-social-icon"
								/>
							</a> */}
							<a
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									style={{ width: 40, height: 40 }}
									icon={faGithub}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									style={{ width: 40, height: 40 }}
									icon={faLinkedin}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={INFO.socials.instagram}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									style={{ width: 40, height: 40 }}
									icon={faInstagram}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={`mailto:${INFO.main.email}`}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									style={{ width: 40, height: 40 }}
									icon={faMailBulk}
									className="homepage-social-icon"
								/>
							</a>
						</div>


						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
